import { Flex, Typography } from "@qws-org/ui-kit";
import type { FC } from "react";

type Props = { index: number };
export const NumberInCircle: FC<Props> = ({ index }) => {
  return (
    <Flex
      align="center"
      justify="center"
      minWidth={40}
      minHeight={40}
      d={{ minWidth: 44, minHeight: 44 }}
      className="rounded-full border-2 border-[var(--colors-text-primary-default)] text-center"
    >
      <Typography size="large">{index}</Typography>
    </Flex>
  );
};
